const flagStatus = Object.freeze({
  DISABLED: 0,
  ENABLED: 1
})

export { flagStatus }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/FlagStatusEnum.js